export const SmartPhoneIcon = (props) => (
  <svg
    className={props.className}
    width="11"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.175 1.8125V14.0625H1.5625V1.8125H9.175ZM10.4875 0.5H0.25V15.375H10.4875V0.5Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.3252 12.3562C5.44601 12.3562 5.54395 12.2583 5.54395 12.1375C5.54395 12.0166 5.44601 11.9187 5.3252 11.9187C5.20438 11.9187 5.10645 12.0166 5.10645 12.1375C5.10645 12.2583 5.20438 12.3562 5.3252 12.3562ZM4.23145 12.1375C4.23145 11.5334 4.72113 11.0437 5.3252 11.0437C5.92926 11.0437 6.41895 11.5334 6.41895 12.1375C6.41895 12.7415 5.92926 13.2312 5.3252 13.2312C4.72113 13.2312 4.23145 12.7415 4.23145 12.1375Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.46289 3.59344L3.63683 3.00647L5.08691 5.90664L6.04941 5.03164L8.27433 9.48147L7.10039 10.0684L5.6503 7.16826L4.6878 8.04326L2.46289 3.59344Z"
      fill="#34363E"
    />
  </svg>
);
